const initialState = {}

export default function contactReducer(state = initialState, action) {
	switch (action.type) {
		default:
			return { ...state }
	}
}
